export const DEFAULT_DOWNLOAD_BUTTON_TEXT = 'Download Report'
export const DEFAULT_DOWNLOAD_BUTTON_ROLE = 'download_button'

export const DEFAULT_FILENAME = 'generated'
export const DEFAULT_FIELD_SEPARATOR = ','
export const DEFAULT_QUOTE_STRINGS = '"'
export const DEFAULT_DECIMAL_SEPARATOR = '.'
export const DEFAULT_SHOW_LABELS = true
export const DEFAULT_SHOW_TITLE = false
export const DEFAULT_TITLE = 'CSV'
export const DEFAULT_USE_TEXT_FILE = false
export const DEFAULT_USE_BOM = true
export const DEFAULT_USE_KEYS_AS_HEADERS = false
